import React, { forwardRef, useState, useCallback, useMemo } from 'react';
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import TaniumMappingForm from './TaniumMappingForm';
import { Divider } from "antd";
import _ from "lodash";

const TYPE = {
    apiEndpoint: 'apiEndpoint',
    taniumConnect: 'taniumConnect', 
}
const TaniumCredentialsForm = forwardRef((props, ref) => {
    const [type, setType] = useState(_.isEmpty(props.config?.bucketName) ? TYPE.apiEndpoint : TYPE.taniumConnect);

    const handleRadioChange = useCallback((e) => {
        setType(e.target.value);
    },[]);

    const apiEndpointFields = useMemo(()=>([
        {
            name: "apiEndpoint",
            label: "API Endpoint",
            required: true,
            rules: [urlRegexValidator]
        },
        {
            name: "token",
            label: "Token",
            required: true,
            type: FieldTypes.PASSWORD,
        }
    ]), []);

    const taniumConnectFields = useMemo(() => ([
        {
            name: "apiEndpoint",
            label: "API Endpoint",
            required: false,
            placeholder: "Leave blank to ingest all findings via S3 Bucket",
            rules: [urlRegexValidator]
        },
        {
            name: "token",
            label: "Token",
            placeholder: "Leave blank to ingest all findings via S3 Bucket",
            required: false,
            type: FieldTypes.PASSWORD
        },
        {
            render:() => <Divider type="horizontal" className="m-y-m"/>
        },
        {
            name: "bucketName",
            label: "S3 Bucket Name",
            required: true,
        },
        {
            name: "region",
            label: "Region",
            required: true,
        },{
            name: "roleArn",
            label: "Role",
            required: true,
        },{
            name: "externalId",
            label: "External Id",
            required: true,
            type: FieldTypes.PASSWORD,
        },{
            name: "folderPath",
            label: "Base Folder Path",
            required: true,
            props: {
                defaultValue: "Tanium/"
            }
        },{
            name: "complyFolderName",
            label: "Comply Folder Name",
            required: true
        },
        {
            name: "patchFolderName",
            label: "Patch Folder Name",
            required: false
        }
    ]),[]);

    const configFields = type === TYPE.apiEndpoint ?  apiEndpointFields : taniumConnectFields;

    const fields = useMemo(() => ([
        {
            name: "authenticationType",
            type: FieldTypes.RADIO,
            options: [
                {
                    label: 'Tanium Connect',
                    value: TYPE.taniumConnect
                },
                {
                    label: 'API Endpoint',
                    value: TYPE.apiEndpoint
                }
            ],
            props: {
                onChange: handleRadioChange,
                defaultValue: type
            }
        },
        ...configFields,
    ]), [handleRadioChange, type, configFields]);

    const parseExtraFields = useCallback((config) => {
        return {
            ...config,
            folderPath: _.isEmpty(config.folderPath) ? "Tanium/" : config.folderPath
        }
    }, [])

    return (
        <GenericPullCredentialsForm 
            {...props} 
            ref={ref}
            fields={fields}
            MappingForm={TaniumMappingForm}
            initialValue={{authenticationType: type, folderPath: "Tanium/"}}
            parseExtraFields={parseExtraFields}
        />
    )
});

export default TaniumCredentialsForm;